import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { SELF_SERVE_UI_CLICKSTREAM } from '@cp/src/service/clickStream.constant';
import FileDownloadButton from '@cp/src/components/Buttons/FileDownloadButton';
import { MockAllocationDetails } from '../../../interface';

const FailureReports = (props: { allocationDetails: MockAllocationDetails }) => {
  const { allocationDetails } = props;

  const postAllocationAgencyAllocationFailureReport =
    allocationDetails?.postAllocationAgencyAllocationFailureReport;

  const postAllocationInHouseAgentAllocationFailureReport =
    allocationDetails?.postAllocationInHouseAgentAllocationFailureReport;

  const postAllocationExternalAgentAllocationFailureReport =
    allocationDetails?.postAllocationExternalAgentAllocationFailureReport;

  const mockId = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails?.allocationTrackerId || ''
  );

  if (
    !postAllocationAgencyAllocationFailureReport &&
    !postAllocationInHouseAgentAllocationFailureReport &&
    !postAllocationExternalAgentAllocationFailureReport
  )
    return null;

  const attribute = {
    mockId: mockId
  };

  return (
    <div className="flex justify-between gap-3">
      <Typography variant="h4" color="var(--grayscale-2)">
        Post allocation failure report:
      </Typography>
      <>
        {postAllocationInHouseAgentAllocationFailureReport ? (
          <FileDownloadButton
            label={'Agent'}
            presignedUrl={postAllocationInHouseAgentAllocationFailureReport}
            fileName="PostAllocationInHouseAgentFailureReport"
            buttonContainer="text-center text-[--blue-base]"
            clickstreamEvent={SELF_SERVE_UI_CLICKSTREAM.LH_DOWNLOAD_POST_ALLOCATION_REPORT_CLICKED}
            attributes={attribute}
          />
        ) : null}
        {postAllocationExternalAgentAllocationFailureReport ? (
          <FileDownloadButton
            label={'OMA Agent'}
            presignedUrl={postAllocationExternalAgentAllocationFailureReport}
            fileName="PostAllocationExternalAgentFailureReport"
            buttonContainer="text-center text-[--blue-base]"
            clickstreamEvent={SELF_SERVE_UI_CLICKSTREAM.LH_DOWNLOAD_POST_ALLOCATION_REPORT_CLICKED}
            attributes={attribute}
          />
        ) : null}
        {postAllocationAgencyAllocationFailureReport ? (
          <FileDownloadButton
            label={'Agency'}
            presignedUrl={postAllocationAgencyAllocationFailureReport}
            fileName="PostAllocationAgencyFailureReport"
            buttonContainer="text-center text-[--blue-base]"
            clickstreamEvent={SELF_SERVE_UI_CLICKSTREAM.LH_DOWNLOAD_POST_ALLOCATION_REPORT_CLICKED}
            attributes={attribute}
          />
        ) : null}
      </>
    </div>
  );
};

export default FailureReports;
